const stateAbbreviations: Record<string, string> = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
  'district of columbia': 'DC',
};

/**
 * Extracts "City, ST" from a full US address string, converting full state
 * names to their two-letter abbreviation when possible.
 * Handles formats:
 *   - "Street Address, City, ST ZIP[, United States]"
 *   - "Street Address, City, State Name ZIP[, United States]"
 *   - "City, State[, United States]"
 * Falls back to the original string if the format can't be parsed.
 */
export function formatLocationShort(
  location: string | null | undefined
): string | undefined {
  if (!location) return;

  const parts = location
    .split(',')
    .map((p) => p.trim())
    .filter(Boolean);

  if (parts.length === 0) return location;

  // Drop trailing "United States" if present
  const trimmed =
    parts[parts.length - 1].toLowerCase() === 'united states'
      ? parts.slice(0, -1)
      : parts;

  if (trimmed.length < 2) return location;

  const stateZip = trimmed[trimmed.length - 1]; // e.g. "NY 11201" or "New York"
  const city = trimmed[trimmed.length - 2]; // e.g. "Brooklyn" or "Pawling"

  // If the state segment contains a ZIP code (e.g. "NY 11201" or "New York 11226"),
  // strip the ZIP to get just the state portion.
  const hasZip = /\d/.test(stateZip);
  const stateName = hasZip ? stateZip.replace(/\s*\d[\d-]*$/, '') : stateZip;

  if (!city || !stateName) return location;

  // Convert full state names to abbreviations (e.g. "New York" → "NY")
  const state =
    stateAbbreviations[stateName.toLowerCase()] ?? stateName;

  return `${city}, ${state}`;
}
